import Link from "next/link";
import { UserIcon } from "lucide-react";

import styles from "./account-element-link.module.css";

/**
 * The header builder's Account element for a signed-out visitor: the person
 * icon plus the operator's label, as the builder preview draws it
 * (`header-footer.preview-header-elements.tsx` `AccountBody` in operator-web).
 * Shared by `<AuthMenu>` and `<AuthIsland>`, so both storefront trees match.
 */
export function AccountElementLink({
  label,
  iconOnlyName,
  href,
}: {
  label: string;
  /** The agency's sign-in address (feature: permalinks). */
  href: string;
  /** The link's accessible name when the operator left the label blank. */
  iconOnlyName: string;
}): React.ReactElement {
  return (
    <Link
      href={href}
      prefetch={false}
      aria-label={label ? undefined : iconOnlyName}
      className={styles.link}
    >
      <UserIcon className={styles.icon} strokeWidth={1.75} aria-hidden />
      {label ? <span>{label}</span> : null}
    </Link>
  );
}
